import { useInbox, useInboxColumns, useInboxLockStatus } from '../hooks';
import { usePagination, useQueryParams } from '@/hooks';
import { InboxRowActions } from './InboxRowActions';
import { InboxFilter } from '../models';
import { Table } from '@/components';
import { useEffect } from 'react';

interface InboxTableProps {
  filter: InboxFilter;
}

const InboxTable = ({ filter }: InboxTableProps) => {
  const { setQueryParams, getQueryParam } = useQueryParams();

  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize: Number(getQueryParam('pageSize')) || 10,
    });

  const { inboxes, totalItems, totalPages, isLoading } = useInbox({
    filters: filter,
    paginated: { page: currentPage, pageSize },
  });

  const columns = useInboxColumns({
    inboxes,
    filter,
    isLoading,
  });

  const { getLockStatus } = useInboxLockStatus();

  const renderActions = (rowData: any) =>
    ['PENDING', 'ATTENDING'].includes(String(rowData.status)) ? (
      <InboxRowActions rowData={rowData} />
    ) : null;

  const getRowStyle = (rowData: any) => {
    const { isTakenByMe } = getLockStatus(rowData);

    if (isTakenByMe) {
      return { border: '2px solid var(--primary-color)' };
    }
    return {};
  };

  useEffect(() => {
    setQueryParams({
      page: currentPage.toString(),
      pageSize: pageSize.toString(),
    });
  }, [currentPage, pageSize]);

  return (
    <div className='w-full p-5 flex flex-col bg-white rounded-lg rounded-ss-none shadow-md gap-5'>
      <Table
        columns={columns}
        data={filter.sector.id ? inboxes : []}
        renderActions={renderActions}
        isLoading={isLoading}
        getRowStyle={getRowStyle}
        pagination={{
          totalItems,
          totalPages,
          currentPage,
          rowsPerPage: pageSize,
          onPageChange: handlePageChange,
          onRowsPerPageChange: handlePageSizeChange,
        }}
      />
    </div>
  );
};

export default InboxTable;
